import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, SubTypeMap, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class ConstructLineLabelExpressionBuilderService {
    title = 'ConstructLineLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[96] = {function: this.buildConstructLineAnnotation.bind(this)};
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    buildConstructLineAnnotation(attributes: Attributes) {
        let labels = [];
        let labelProperties = {} as labelProperties;

        if (attributes.attribute1) {
            let attribute1 = isNaN(attributes.attribute1)
                ? attributes.attribute1
                : this.labelExpressionUtilityService.round(attributes.attribute1, 2);

            labels.push(this.labelExpressionUtilityService.getLabelProperties('7.2em', 'italic', 'middle', attribute1));

            labelProperties.labels = labels;
            labelProperties.labelExpression = this.labelExpressionUtilityService.formatLabel(attribute1, 7.2, false);

            return labelProperties;
        }

        return null;
    }
}
